import requests from 'service/api'
import AsyncSearchSelect from '../async-search-select'
import { asOptions, firstOption } from 'lib/asyncList'

export function SelectAdditionalInstructions({ name }) {
  const mapPhrase = ({ id, name: label }) => ({ value: id, label })
  return (
    <AsyncSearchSelect
      name={name}
      fetchSelected={(id) => firstOption(requests.additionalPhrases.list({ selected: id }), mapPhrase)}
      fetchOptions={(search) => asOptions(requests.additionalPhrases.list({ search, limit: 20 }), mapPhrase)}
    />
  )
}
